import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Input, Space, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import RightSidebarGlobal from '../../Components/RightSidebarGlobal';
import Loader from '../../Components/Loader';
import { BASE_BENFED_URL } from '../../routes/config';
import * as Yup from 'yup';
import { useFormik } from "formik";
// import { Select, Spin } from "antd";


const initialValues = {
  district_list: '',
};

const validationSchema = Yup.object({
  // select_type: Yup.string().required('Please select either District or Range'),
  district_list: Yup.string(),
});

function WareHouse() {
  const [loading, setLoading] = useState(true);
  const [getPageData, setPageData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [getDistrictList, setDistrictList] = useState([]);

  const [formValues, setFormValues]  = useState();
   
    
   
  const onSubmit = (values) => {
    console.log(values, 'valuesvaluesvaluesvaluesvalues');
    setFormValues(values)
  };

  const formik = useFormik({
    initialValues,
    // initialValues : formik.values.district_list,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
    validateOnMount: true,
  });



  const fetchdata = ()=>{
  
    axios.post(`${BASE_BENFED_URL}/f_dist_api`,
   {
     auth_key:"xxxxx",
     doc_type: 4
   }
   // ,
   // {
   //     headers: {
   //         Authorization: loginData.token,
   //     },
   // }
   ).then(res => {

    
     if(res.status == '200'){
      setDistrictList(res?.data?.value);
      //  setPageTitle(res.data.title);
      //  setFolderLocation(res?.data?.folder_name)
       setLoading(false)
      console.log(res , 'uuuuuuuuuuuuuuuuuuuuuu', res?.data?.value);

    } else {
      setDistrictList([])
      setLoading(false)
    }
       
      //  if(res.data.suc > 0){
      //     //  setPageData(res?.data?.msg);
      //     //  setPageTitle(res.data.title);
      //     //  setFolderLocation(res?.data?.folder_name)
      //      setLoading(false)
      //      // setFolderLocation()
           

      //      // pageDataCheck = res.data.status;
      //  } else {
      //    setPageData([])
      //    setLoading(false)
      //    // pageDataCheck = res.data.status;
      //  }
 
       

   }) 

  }


  

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={text ? text.toString() : ''} />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Name of Godown',
      dataIndex: 'w_name',
      key: 'w_name',
      width: '15%',
      // ...getColumnSearchProps('doc_title'),
    },
    {
      title: 'Location',
      dataIndex: 'w_addrs',
      key: 'w_addrs',
      width: '25%',
      // ...getColumnSearchProps('document'),
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
      width: '10%',
      // ...getColumnSearchProps('document'),
    },
    {
      title: 'Capacity',
      dataIndex: 'capacity',
      key: 'capacity',
      width: '10%',
      render: (text) => `${parseFloat(text).toFixed(0)} MT`
      // ...getColumnSearchProps('document'),
    },
    {
      title: 'Current Status',
      dataIndex: 'pres_status',
      key: 'pres_status',
      width: '10%',
      // ...getColumnSearchProps('document'),
    },
    {
      title: 'Controlling Authority',
      dataIndex: 'pres_status',
      key: 'pres_status',
      width: '30%',
      render: (_, record) => `District Manager, BENFED ${record.district_name} ${record.contact_no}`
      // ...getColumnSearchProps('document'),
    },
  ];

  const handleDistrictChange = (event)=>{
    console.log(event.target.value, 'ggggg');
    

    formik.setFieldValue('district_list', event.target.value);
    
    axios.post(`${BASE_BENFED_URL}/f_godown_api`,
      {
        dist_id:event.target.value,
      }
      ,
      // {
      // headers: {
      //   auth_key: 'c299cf0ae55ac8a2e3932b65fe5f08538962c5114d5680db8193eb2d3116',
      // },
      // }
      {headers: {
        "Content-Type": "application/json"
      }
      }
      ).then(res => {
   
      //  console.log(res , 'tttttttttttttt');
        if(res.status == '200'){
          setPageData(res?.data?.value);
          setLoading(false)
         console.log(res , 'ddddddddddd', res?.data?.value);
   
       } else {
         setPageData([])
         setLoading(false)
       }
          
        
    
          
   
      }) 
  }

  useEffect(()=>{
    fetchdata();
    },[])

  return (
    <div className="wrapper">
      <div className="inner_page_Sec">
        <div className="col-sm-12 float-left left_sec searchPageTop">
          <h1>Warehouse</h1>
          <div class="row">
      <div className='form_grievance'>
    <form onSubmit={formik.handleSubmit}>
    <div class="col-lg-6">
  <label for="exampleFormControlInput1" class="form-label">Select District</label>

    <div class="input-group">

      <select
      className="form-control"
      name="district_list"
      onChange={handleDistrictChange} 
      onBlur={formik.handleBlur}
      value={formik.values.district_list}
      >
      <option value="" disabled>Select Name</option>
      {getDistrictList.map((item, index) => (
      <option key={index} value={item.district_code}>
      {item.district_name}
      </option>
      ))}
      </select>

      {/* <Select
      showSearch // Search
      placeholder="Choose Sector"
      value={formik.values.district_list || undefined} // Ensure default empty state
      onChange={(value) => {
      handleDistrictChange
      // formik.setFieldValue("district_list", value)
      // console.log(value, 'ggggggggggggggggggg');
      }}
      onBlur={formik.handleBlur}
      style={{ width: "100%" }}
      optionFilterProp="children"

      filterOption={(input, option) => // Search
      option?.children?.toLowerCase().includes(input.toLowerCase()) // Search
      } // Search
      >
      <Select.Option value="" disabled> Choose Sector </Select.Option>
      {sectorDropList?.map(data => (
      <Select.Option key={data.sl_no} value={data.sl_no}>
      {data.sector_desc}
      </Select.Option>
      ))}
      </Select> */}

  {formik.errors.district_list && formik.touched.district_list && (
    <div className="required">{formik.errors.district_list}</div>
  )}
    </div>
  </div>
  </form>
  </div>
  </div>

  <div className='row'>
          <div className="col-lg-12 warehouse_table">
            {/* <p>Three columns with information regarding Godown Type, Godown Capacy and details of controlling officer may be added</p> */}
            {loading ? <Loader align="center" gap="middle" size="large" /> : 
            <>
            {getPageData.length > 0 &&(
               <Table columns={columns} dataSource={getPageData} scroll={{ x: 'max-content' }} />
            )}
            </>
           }
          </div>
<div className="col-lg-12">
<p>The matters related to maintenance of Godown and utitization through proper means is dealt by <strong>Planning & Delelopmenrt (P&D) 
  cell</strong> at BENFED Head Office with active support and participation from other departments and branch offices under overall guidance 
  of General Manager (Administration), BENFED. The cell is headed by Manager (Planning & Development). Presently Manager 
  (Agri inputs & Fertilizer) is holding that portfolio as additional charge. Other people responsible are as follows:-</p>

  <ul class="list_cus">
    <li>Deputy Manager (P&D) in-charge of P&D matters</li>
    <li>Deputy Manager (P&D)  Mob.  9674746915</li>
    <li>Asstt. Manager (P&D)  Mob.  9674746905</li>
    <li>Sri Samik Mukherjee </li>
  </ul>

</div>

          
          </div>
        </div>
        {/* <div className="col-sm-4 float-left">
          <RightSidebarGlobal />
        </div> */}
      </div>
    </div>
  );
}

export default WareHouse;
